import { useEffect, useRef } from 'react';

import styles from './Confetti.module.css';

import confetti from 'assets/video/confetti.webm';

export const Confetti = ({ startDelay = 1000 }) => {
  const confettiRef = useRef(null);

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, startDelay);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [startDelay]);

  return (
    <div className={styles.videoWrapper}>
      <video
        ref={confettiRef}
        muted="muted"
        loop
        playsInline
        className={styles.confetti}
      >
        <source src={confetti} type="video/webm" />
      </video>
    </div>
  );
};
